import FriendshipDeckIMG from "../../assets/DeckCards/Relationships/FriendshipDeckIMG.png";
import RomanticRelationshipsDeckIMG from "../../assets/DeckCards/Relationships/RomanticRelationshipsDeckIMG.png";
import SocialRelationsDeckIMG from "../../assets/DeckCards/Relationships/SocialRelationsDeckIMG.png";
import FormalRelationsDeckIMG from "../../assets/DeckCards/Relationships/FormalRelationsDeckIMG.png";


//test
export const RelationshipsDeckFace = [

    {
        id: "friendship",
        Title: "Friendship",
        Description: "Learn words for friends, companions, and close peers.",
        Difficulty: "Beginner 2",
        Image: FriendshipDeckIMG,
        Link: "/FriendshipDeck",
        cssId: "friendship-ID"
    },
        {
        id: "romantic_relationships",
        Title: "Romantic Relationships",
        Description: "Learn vocabulary for dating, partners, and romantic connections.",
        Difficulty: "Beginner 2",
        Image: RomanticRelationshipsDeckIMG,
        Link: "/RomanticRelationsDeck",
        cssId: "romantic-relationships-ID"
    },

    {
        id: "social_relations",
        Title: "Acquaintances & Social Relations",
        Description: "Learn vocabulary for neighbors, classmates, and more.",
        Difficulty: "Beginner 2",
        Image: SocialRelationsDeckIMG,
        Link: "/SocialRelationsDeck",
        cssId: "social-relations-ID"
    },

    {
        id: "formal_relations",
        Title: "Formal & Honorific Relations",
        Description: "Learn respectful and professional relationship terms.",
        Difficulty: "Beginner 2",
        Image: FormalRelationsDeckIMG,
        Link: "/FormalRelationsDeck",
        cssId: "formal-relations-ID"
    },

];
